'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { customValidationException } from '@app/_components/error/CustomValidationException';
import { Modal } from '@endurancewarranty/ui';
import { customErrorAtom } from '@states/customError/customErrorAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
import type { FC } from 'react';
export const CustomErrorModal: FC = () => {
  const $ = _c(12);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useJotaiAtom(customErrorAtom);
  let t0;
  if ($[0] !== setError) {
    t0 = () => {
      setError(_temp);
      setIsOpen(false);
    };
    $[0] = setError;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClose = t0;
  let t1;
  let t2;
  if ($[2] !== error.error) {
    t1 = () => {
      if (error.error != null) {
        setIsOpen(true);
      }
    };
    t2 = [error.error];
    $[2] = error.error;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== error.error || $[6] !== onClose) {
    t3 = error.error && customValidationException[error.error.customValidationException.errorType].component(onClose, error.error.customValidationException.parameters);
    $[5] = error.error;
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isOpen || $[9] !== onClose || $[10] !== t3) {
    t4 = <Modal className="w-[400px]" isOpen={isOpen} onClose={onClose} hasCloseButton={false}>{t3}</Modal>;
    $[8] = isOpen;
    $[9] = onClose;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(previous) {
  return {
    ...previous,
    error: null
  };
}